/**
 * PKCE (Proof Key for Code Exchange) utilities for OAuth 2.0 flow
 */

/**
 * Generates a random string of specified length
 */
export function randomString(length: number): string {
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let text = '';
  
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  
  return text;
}

/**
 * Generates a code verifier string for PKCE
 * Between 43-128 characters as per spec
 */
export function generateCodeVerifier(): string {
  return randomString(96);
}

/**
 * Creates a code challenge from a code verifier using SHA-256
 */
export async function generateCodeChallenge(codeVerifier: string): Promise<string> {
  // Convert string to ArrayBuffer
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  
  // Generate SHA-256
  const hash = await crypto.subtle.digest('SHA-256', data);
  
  // Convert to base64 URL-safe string
  return base64URLEncode(hash);
}

/**
 * Encodes an ArrayBuffer to a base64 URL-safe string
 */
function base64URLEncode(buffer: ArrayBuffer): string {
  // Convert ArrayBuffer to base64
  const base64 = btoa(String.fromCharCode(...new Uint8Array(buffer)));
  // Make base64 URL-safe
  return base64
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
} 